import { useContext } from 'react';

import { AnnotationsAxisConfigContext } from '../contexts/AnnotationsAxisConfig.context.js';

export const useAnnotationsAxisConfig = () =>
  useContext(AnnotationsAxisConfigContext);
